function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Icon from '../icon';
import { buildComponentName } from '../utils';
export default {
  name: buildComponentName('Avatar'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-avatar'
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(val) {
        return ['default', 'large', 'small', ''].indexOf(val) > -1;
      }
    },
    shape: {
      type: String,
      default: 'circle',
      validator: function validator(val) {
        return ['square', 'circle'].indexOf(val) > -1;
      }
    },
    src: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isExistsImage: true,
      scale: 1,
      txtOffsetWidth: 0
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          size = this.size,
          shape = this.shape,
          icon = this.icon,
          src = this.src,
          isExistsImage = this.isExistsImage;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(size === 'large' ? 'lg' : 'sm'), size === 'small' || size === 'large'), _defineProperty(_ref, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_ref, "".concat(prefixCls, "-icon"), icon), _defineProperty(_ref, "".concat(prefixCls, "-image"), src && isExistsImage), _ref;
    },
    style: function style() {
      var scale = this.scale,
          txtOffsetWidth = this.txtOffsetWidth;
      var r = {};

      if (scale >= 1) {
        r = {};
      } else {
        r = {
          position: 'absolute',
          display: 'inline-block',
          left: "calc(50% - ".concat(txtOffsetWidth / 2, "px)"),
          transform: "scale(".concat(scale, ")")
        };
      }

      return r;
    }
  },
  mounted: function mounted() {
    this.prevAvatarTextRef = null;
    this.setScale();
  },
  updated: function updated() {
    this.setScale();
  },
  methods: {
    onError: function onError() {
      this.isExistsImage = false;
    },
    setScale: function setScale() {
      var $el = this.$el,
          avatarTextRef = this.$refs.avatarTextRef,
          prevAvatarTextRef = this.prevAvatarTextRef;

      if (avatarTextRef && $el) {
        if (prevAvatarTextRef && avatarTextRef.innerHTML === prevAvatarTextRef.innerHTML) {
          return;
        }

        this.prevAvatarTextRef = avatarTextRef.cloneNode(true);
        var txtW = avatarTextRef.offsetWidth;
        var wrapW = $el.getBoundingClientRect().width - 8;
        var scale = txtW === 0 ? 1 : wrapW / txtW;

        if (scale < 1) {
          this.txtOffsetWidth = txtW;
          this.scale = scale;
        } else {
          this.scale = 1;
        }
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        classes = this.classes,
        style = this.style,
        src = this.src,
        isExistsImage = this.isExistsImage,
        icon = this.icon,
        onError = this.onError;
    var element = null;

    if (src && isExistsImage) {
      element = h("img", {
        "attrs": {
          "src": src
        },
        "on": {
          "error": onError
        }
      });
    } else if (icon) {
      element = h(Icon, {
        "attrs": {
          "type": icon
        }
      });
    } else {
      var slotDefault = $slots.default;
      element = h("span", {
        "ref": "avatarTextRef",
        "style": style
      }, [slotDefault]);
    }

    return h("span", {
      "ref": "avatarWrapref",
      "class": classes
    }, [element]);
  }
};